
// import jwtDecode from 'jwt-decode'
import { CONTANTS } from '~/constants';
// REFERENCE
// https://dev.to/sahilkashyap64/google-identity-servicegoogle-auth-2022-in-react-node-27lh
// https://developers.google.com/identity/oauth2/web/guides/migration-to-gis?hl=vi#gapi-client-library
export default {
  props: {},

  computed: {},

  methods: {
    async login() {
      if (!window.google) {
        return;
      }

      const client = window.google.accounts.oauth2.initTokenClient({
        client_id: CONTANTS.GG_CLIENT_ID,
        scope: 'profile email',
        callback: '',
        // allowed_parent_origin: 'http://localhost:4000',
      });

      const tokenResponse = await new Promise((resolve, reject) => {
        try {
          // Settle this promise in the response callback for requestAccessToken()
          client.callback = (resp) => {
            if (resp.error !== undefined) {
              reject(resp);
            }

            // console.log("client resp",resp);
            resolve(resp);
          };
          // console.log("client",client);
          client.requestAccessToken({ prompt: 'consent' });
        } catch (err) {
          console.log(err);
        }
      });
      this.fetchApi(tokenResponse);
      // return tokenResponse
    },

    async fetchApi({ access_token }) {
      if (access_token) {
        const { data } = await this.$axios.request({
          url: '/rest-auth/google/',
          method: 'post',
          data: {
            access_token,
          },
        });

        if (data) {
          const {
            user,
            access_token,
            refresh_token,
            access_token_expiration,
            refresh_token_expiration,
          } = data;

          const payload = {
            access_token,
            refresh_token,
            access_token_expiration,
            refresh_token_expiration,
            type: 'google',
          };

          this.$store.dispatch('auth/oauth', { user, payload });
          await this.$store.dispatch("config/fetchConfigs", true);
          this.$router.push('/invoice');
        }
      }
    },
  },
};
